function getFocusableElements(container) {
	return Array.from(
		container.querySelectorAll(
			"summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
		)
	);
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
	summary.setAttribute('role', 'button');
	summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

	if (summary.nextElementSibling.getAttribute('id')) {
		summary.setAttribute('aria-controls', summary.nextElementSibling.id);
	}

	summary.addEventListener('click', (event) => {
		event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
	});

	if (summary.closest('header-drawer, menu-drawer')) return;
	summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
	var elements = getFocusableElements(container);
	var first = elements[0];
	var last = elements[elements.length - 1];

	removeTrapFocus();

	trapFocusHandlers.focusin = (event) => {
		if (event.target !== container && event.target !== last && event.target !== first) return;

		document.addEventListener('keydown', trapFocusHandlers.keydown);
	};

	trapFocusHandlers.focusout = function () {
		document.removeEventListener('keydown', trapFocusHandlers.keydown);
	};

	trapFocusHandlers.keydown = function (event) {
		if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
		// On the last focusable element and tab forward, focus the first element.
		if (event.target === last && !event.shiftKey) {
			event.preventDefault();
			first.focus();
		}

		//  On the first focusable element and tab backward, focus the last element.
		if ((event.target === container || event.target === first) && event.shiftKey) {
			event.preventDefault();
			last.focus();
		}
	};

	document.addEventListener('focusout', trapFocusHandlers.focusout);
	document.addEventListener('focusin', trapFocusHandlers.focusin);

	elementToFocus.focus();

	if (
		elementToFocus.tagName === 'INPUT' &&
		['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
		elementToFocus.value
	) {
		elementToFocus.setSelectionRange(0, elementToFocus.value.length);
	}
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
	document.querySelector(':focus-visible');
} catch (e) {
	focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
	const navKeys = [
		'ARROWUP',
		'ARROWDOWN',
		'ARROWLEFT',
		'ARROWRIGHT',
		'TAB',
		'ENTER',
		'SPACE',
		'ESCAPE',
		'HOME',
		'END',
		'PAGEUP',
		'PAGEDOWN'
	];
	let currentFocusedElement = null;
	let mouseClick = null;

	window.addEventListener('keydown', (event) => {
		if (navKeys.includes(event.code.toUpperCase())) {
			mouseClick = false;
		}
	});

	window.addEventListener('mousedown', (event) => {
		mouseClick = true;
	});

	window.addEventListener(
		'focus',
		() => {
			if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

			if (mouseClick) return;

			currentFocusedElement = document.activeElement;
			currentFocusedElement.classList.add('focused');
		},
		true
	);
}

function pauseAllMedia() {
	document.querySelectorAll('.js-youtube').forEach((video) => {
		video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
	});
	document.querySelectorAll('.js-vimeo').forEach((video) => {
		video.contentWindow.postMessage('{"method":"pause"}', '*');
	});
	document.querySelectorAll('video').forEach((video) => video.pause());
	document.querySelectorAll('product-model').forEach((model) => {
		if (model.modelViewerUI) model.modelViewerUI.pause();
	});
}

function removeTrapFocus(elementToFocus = null) {
	document.removeEventListener('focusin', trapFocusHandlers.focusin);
	document.removeEventListener('focusout', trapFocusHandlers.focusout);
	document.removeEventListener('keydown', trapFocusHandlers.keydown);

	if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
	if (event.code.toUpperCase() !== 'ESCAPE') return;

	const openDetailsElement = event.target.closest('details[open]');
	if (!openDetailsElement) return;

	const summaryElement = openDetailsElement.querySelector('summary');
	openDetailsElement.removeAttribute('open');
	summaryElement.setAttribute('aria-expanded', false);
	summaryElement.focus();
}

class QuantityInput extends HTMLElement {
	constructor() {
		super();
		this.input = this.querySelector('input');
		this.locked = this.input.dataset.lockedQty === 'true';
		this.changeEvent = new Event('change', { bubbles: true });
		this.input.addEventListener('change', this.onInputChange.bind(this));
		this.querySelectorAll('button').forEach((button) =>
			button.addEventListener('click', this.onButtonClick.bind(this))
		);
	}

	quantityUpdateUnsubscriber = undefined;

	connectedCallback() {
		this.validateQtyRules();
		this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));

		const runLockCheck = () => {
			requestAnimationFrame(() => {
				const lockedVariantIds = window.cusaLockedVariantIds || [];
				const variantId = this.input.dataset.quantityVariantId;

				if (lockedVariantIds.includes(variantId)) {
					this.locked = true;
				}

				if (this.locked) {
					this.input.setAttribute('readonly', 'true');
					this.querySelectorAll('button').forEach((btn) => {
						btn.setAttribute('disabled', 'true');
						btn.classList.add('disabled');
					});
					this.input.setAttribute('disabled', 'true');
					this.input.classList.add('disabled');
					this.classList.add('locked-qty');
				}
			});
		};

		if (document.readyState === 'complete') {
			runLockCheck();
		} else {
			window.addEventListener('load', runLockCheck, { once: true });
		}
	}

	disconnectedCallback() {
		if (this.quantityUpdateUnsubscriber) {
			this.quantityUpdateUnsubscriber();
		}
	}

	onInputChange(event) {
		if (this.locked) {
			this.input.value = 1;
			return;
		}
		this.validateQtyRules();
		const productInfoEl = document.querySelector('product-info');
		if (productInfoEl && productInfoEl.contains(event.target)) {
			publish(PUB_SUB_EVENTS.updateRoyalty, getLocalStorage('selected-cause'));
		}
	}

	onButtonClick(event) {
		if (this.locked) return;
		event.preventDefault();
		const previousValue = this.input.value;
		event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
		if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
	}

	validateQtyRules() {
		const value = parseInt(this.input.value);
		if (this.input.min) {
			const min = parseInt(this.input.min);
			const buttonMinus = this.querySelector(".quantity__button[name='minus']");
			buttonMinus.classList.toggle('disabled', value <= min);
		}
		if (this.input.max) {
			const max = parseInt(this.input.max);
			const buttonPlus = this.querySelector(".quantity__button[name='plus']");
			buttonPlus.classList.toggle('disabled', value >= max);
		}
	}
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
	let t;
	return (...args) => {
		clearTimeout(t);
		t = setTimeout(() => fn.apply(this, args), wait);
	};
}

function throttle(fn, delay) {
	let lastCall = 0;
	return function (...args) {
		const now = new Date().getTime();
		if (now - lastCall < delay) {
			return;
		}
		lastCall = now;
		return fn(...args);
	};
}

function fetchConfig(type = 'json') {
	return {
		method: 'POST',
		headers: { 'Content-Type': 'application/json', Accept: `application/${type}` }
	};
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
	window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
	return function () {
		return fn.apply(scope, arguments);
	};
};

Shopify.setSelectorByValue = function (selector, value) {
	for (var i = 0, count = selector.options.length; i < count; i++) {
		var option = selector.options[i];
		if (value == option.value || value == option.innerHTML) {
			selector.selectedIndex = i;
			return i;
		}
	}
};

Shopify.addListener = function (target, eventName, callback) {
	target.addEventListener
		? target.addEventListener(eventName, callback, false)
		: target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
	options = options || {};
	var method = options['method'] || 'post';
	var params = options['parameters'] || {};

	var form = document.createElement('form');
	form.setAttribute('method', method);
	form.setAttribute('action', path);

	for (var key in params) {
		var hiddenField = document.createElement('input');
		hiddenField.setAttribute('type', 'hidden');
		hiddenField.setAttribute('name', key);
		hiddenField.setAttribute('value', params[key]);
		form.appendChild(hiddenField);
	}
	document.body.appendChild(form);
	form.submit();
	document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
	this.countryEl = document.getElementById(country_domid);
	this.provinceEl = document.getElementById(province_domid);
	this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

	Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

	this.initCountry();
	this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
	initCountry: function () {
		var value = this.countryEl.getAttribute('data-default');
		Shopify.setSelectorByValue(this.countryEl, value);
		this.countryHandler();
	},

	initProvince: function () {
		var value = this.provinceEl.getAttribute('data-default');
		if (value && this.provinceEl.options.length > 0) {
			Shopify.setSelectorByValue(this.provinceEl, value);
		}
	},

	countryHandler: function (e) {
		var opt = this.countryEl.options[this.countryEl.selectedIndex];
		var raw = opt.getAttribute('data-provinces');
		var provinces = JSON.parse(raw);

		this.clearOptions(this.provinceEl);
		if (provinces && provinces.length == 0) {
			this.provinceContainer.style.display = 'none';
		} else {
			for (var i = 0; i < provinces.length; i++) {
				var opt = document.createElement('option');
				opt.value = provinces[i][0];
				opt.innerHTML = provinces[i][1];
				this.provinceEl.appendChild(opt);
			}

			this.provinceContainer.style.display = '';
		}
	},

	clearOptions: function (selector) {
		while (selector.firstChild) {
			selector.removeChild(selector.firstChild);
		}
	},

	setOptions: function (selector, values) {
		for (var i = 0, count = values.length; i < values.length; i++) {
			var opt = document.createElement('option');
			opt.value = values[i];
			opt.innerHTML = values[i];
			selector.appendChild(opt);
		}
	}
};

class MenuDrawer extends HTMLElement {
	constructor() {
		super();

		this.mainDetailsToggle = this.querySelector('details');

		this.addEventListener('keyup', this.onKeyUp.bind(this));
		this.addEventListener('focusout', this.onFocusOut.bind(this));
		this.bindEvents();
	}

	bindEvents() {
		this.querySelectorAll('summary').forEach((summary) =>
			summary.addEventListener('click', this.onSummaryClick.bind(this))
		);
		this.querySelectorAll(
			'button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button)'
		).forEach((button) => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
	}

	onKeyUp(event) {
		if (event.code.toUpperCase() !== 'ESCAPE') return;

		const openDetailsElement = event.target.closest('details[open]');
		if (!openDetailsElement) return;

		openDetailsElement === this.mainDetailsToggle
			? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
			: this.closeSubmenu(openDetailsElement);
	}

	onSummaryClick(event) {
		const summaryElement = event.currentTarget;
		const detailsElement = summaryElement.parentNode;
		const parentMenuElement = detailsElement.closest('.has-submenu');
		const isOpen = detailsElement.hasAttribute('open');
		const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

		function addTrapFocus() {
			trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
			summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
		}

		if (detailsElement === this.mainDetailsToggle) {
			if (isOpen) event.preventDefault();
			isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

			if (window.matchMedia('(max-width: 990px)')) {
				document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
			}
		} else {
			setTimeout(() => {
				detailsElement.classList.add('menu-opening');
				summaryElement.setAttribute('aria-expanded', true);
				parentMenuElement && parentMenuElement.classList.add('submenu-open');
				!reducedMotion || reducedMotion.matches
					? addTrapFocus()
					: summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
			}, 100);
		}
	}

	openMenuDrawer(summaryElement) {
		setTimeout(() => {
			this.mainDetailsToggle.classList.add('menu-opening');
		});
		summaryElement.setAttribute('aria-expanded', true);
		trapFocus(this.mainDetailsToggle, summaryElement);
		document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
	}

	closeMenuDrawer(event, elementToFocus = false) {
		if (event === undefined) return;

		this.mainDetailsToggle.classList.remove('menu-opening');
		this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
			details.removeAttribute('open');
			details.classList.remove('menu-opening');
		});
		this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
			submenu.classList.remove('submenu-open');
		});
		document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
		removeTrapFocus(elementToFocus);
		this.closeAnimation(this.mainDetailsToggle);

		if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
	}

	onFocusOut() {
		setTimeout(() => {
			if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
				this.closeMenuDrawer();
		});
	}

	onCloseButtonClick(event) {
		const detailsElement = event.currentTarget.closest('details');
		this.closeSubmenu(detailsElement);
	}

	closeSubmenu(detailsElement) {
		const parentMenuElement = detailsElement.closest('.submenu-open');
		parentMenuElement && parentMenuElement.classList.remove('submenu-open');
		detailsElement.classList.remove('menu-opening');
		detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
		removeTrapFocus(detailsElement.querySelector('summary'));
		this.closeAnimation(detailsElement);
	}

	closeAnimation(detailsElement) {
		let animationStart;

		const handleAnimation = (time) => {
			if (animationStart === undefined) {
				animationStart = time;
			}

			const elapsedTime = time - animationStart;

			if (elapsedTime < 400) {
				window.requestAnimationFrame(handleAnimation);
			} else {
				detailsElement.removeAttribute('open');
				if (detailsElement.closest('details[open]')) {
					trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
				}
			}
		};

		window.requestAnimationFrame(handleAnimation);
	}
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
	constructor() {
		super();
	}

	openMenuDrawer(summaryElement) {
		this.header = this.header || document.querySelector('.section-header');
		this.borderOffset =
			this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
		document.documentElement.style.setProperty(
			'--header-bottom-position',
			`${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
		);
		this.header.classList.add('menu-open');

		setTimeout(() => {
			this.mainDetailsToggle.classList.add('menu-opening');
		});

		summaryElement.setAttribute('aria-expanded', true);
		window.addEventListener('resize', this.onResize);
		trapFocus(this.mainDetailsToggle, summaryElement);
		document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
	}

	closeMenuDrawer(event, elementToFocus) {
		if (!elementToFocus) return;
		super.closeMenuDrawer(event, elementToFocus);
		this.header.classList.remove('menu-open');
		window.removeEventListener('resize', this.onResize);
	}

	onResize = () => {
		this.header &&
			document.documentElement.style.setProperty(
				'--header-bottom-position',
				`${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
			);
		document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
	};
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
	constructor() {
		super();
		this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
		this.addEventListener('keyup', (event) => {
			if (event.code.toUpperCase() === 'ESCAPE') this.hide();
		});
		if (this.classList.contains('media-modal')) {
			this.addEventListener('pointerup', (event) => {
				if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
			});
		} else {
			this.addEventListener('click', (event) => {
				if (event.target === this) this.hide();
			});
		}
	}

	connectedCallback() {
		if (this.moved) return;
		this.moved = true;
		document.body.appendChild(this);
	}

	show(opener) {
		this.openedBy = opener;
		const popup = this.querySelector('.template-popup');
		document.body.classList.add('overflow-hidden');
		this.setAttribute('open', '');
		if (popup) popup.loadContent();
		trapFocus(this, this.querySelector('[role="dialog"]'));
		window.pauseAllMedia();
	}

	hide() {
		document.body.classList.remove('overflow-hidden');
		document.body.dispatchEvent(new CustomEvent('modalClosed'));
		this.removeAttribute('open');
		removeTrapFocus(this.openedBy);
		window.pauseAllMedia();
	}
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
	constructor() {
		super();

		const button = this.querySelector('button');

		if (!button) return;
		button.addEventListener('click', () => {
			const modal = document.querySelector(this.getAttribute('data-modal'));
			if (modal) modal.show(button);
		});
	}
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
	constructor() {
		super();
		const poster = this.querySelector('[id^="Deferred-Poster-"]');
		if (!poster) return;
		poster.addEventListener('click', this.loadContent.bind(this));
	}

	loadContent(focus = true) {
		window.pauseAllMedia();
		if (!this.getAttribute('loaded')) {
			const content = document.createElement('div');
			content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

			this.setAttribute('loaded', true);
			const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
			if (focus) deferredElement.focus();
			if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
				// force autoplay for safari
				deferredElement.play();
			}
		}
	}
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
	constructor() {
		super();
		this.slider = this.querySelector('[id^="Slider-"]');
		this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
		this.enableSliderLooping = false;
		this.currentPageElement = this.querySelector('.slider-counter--current');
		this.pageTotalElement = this.querySelector('.slider-counter--total');
		this.prevButton = this.querySelector('button[name="previous"]');
		this.nextButton = this.querySelector('button[name="next"]');

		if (!this.slider || !this.nextButton) return;

		this.initPages();
		const resizeObserver = new ResizeObserver((entries) => this.initPages());
		resizeObserver.observe(this.slider);

		this.slider.addEventListener('scroll', this.update.bind(this));
		this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
		this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
	}

	initPages() {
		this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
		if (this.sliderItemsToShow.length < 2) return;
		this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
		this.slidesPerPage = Math.floor(
			(this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
		);
		this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
		this.update();
	}

	resetPages() {
		this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
		this.initPages();
	}

	update() {
		// Temporarily prevents unneeded updates resulting from variant changes
		// This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
		if (!this.slider || !this.nextButton) return;

		const previousPage = this.currentPage;
		this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

		if (this.currentPageElement && this.pageTotalElement) {
			this.currentPageElement.textContent = this.currentPage;
			this.pageTotalElement.textContent = this.totalPages;
		}

		if (this.currentPage != previousPage) {
			this.dispatchEvent(
				new CustomEvent('slideChanged', {
					detail: {
						currentPage: this.currentPage,
						currentElement: this.sliderItemsToShow[this.currentPage - 1]
					}
				})
			);
		}

		if (this.enableSliderLooping) return;

		if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
			this.prevButton.setAttribute('disabled', 'disabled');
		} else {
			this.prevButton.removeAttribute('disabled');
		}

		if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
			this.nextButton.setAttribute('disabled', 'disabled');
		} else {
			this.nextButton.removeAttribute('disabled');
		}
	}

	isSlideVisible(element, offset = 0) {
		const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
		return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
	}

	onButtonClick(event) {
		event.preventDefault();
		const step = event.currentTarget.dataset.step || 1;
		this.slideScrollPosition =
			event.currentTarget.name === 'next'
				? this.slider.scrollLeft + step * this.sliderItemOffset
				: this.slider.scrollLeft - step * this.sliderItemOffset;
		this.setSlidePosition(this.slideScrollPosition);
	}

	setSlidePosition(position) {
		this.slider.scrollTo({
			left: position
		});
	}
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
	constructor() {
		super();
		this.sliderControlWrapper = this.querySelector('.slider-buttons');
		this.enableSliderLooping = true;

		if (!this.sliderControlWrapper) return;

		this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
		if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

		this.announcementBarSlider = this.querySelector('.announcement-bar-slider');
		// Value below should match --duration-announcement-bar CSS value
		this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

		this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
		this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
		this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
		this.setSlideVisibility();

		if (this.announcementBarSlider) {
			this.announcementBarArrowButtonWasClicked = false;

			this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
			this.reducedMotion.addEventListener('change', () => {
				if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
			});

			[this.prevButton, this.nextButton].forEach((button) => {
				button.addEventListener(
					'click',
					() => {
						this.announcementBarArrowButtonWasClicked = true;
					},
					{ once: true }
				);
			});
		}

		if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
	}

	setAutoPlay() {
		this.autoplaySpeed = this.slider.dataset.speed * 1000;
		this.addEventListener('mouseover', this.focusInHandling.bind(this));
		this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
		this.addEventListener('focusin', this.focusInHandling.bind(this));
		this.addEventListener('focusout', this.focusOutHandling.bind(this));

		if (this.querySelector('.slideshow__autoplay')) {
			this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
			this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
			this.autoplayButtonIsSetToPlay = true;
			this.play();
		} else {
			this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked ? this.pause() : this.play();
		}
	}

	onButtonClick(event) {
		super.onButtonClick(event);
		this.wasClicked = true;

		const isFirstSlide = this.currentPage === 1;
		const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

		if (!isFirstSlide && !isLastSlide) {
			this.applyAnimationToAnnouncementBar(event.currentTarget.name);
			return;
		}

		if (isFirstSlide && event.currentTarget.name === 'previous') {
			this.slideScrollPosition =
				this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
		} else if (isLastSlide && event.currentTarget.name === 'next') {
			this.slideScrollPosition = 0;
		}

		this.setSlidePosition(this.slideScrollPosition);

		this.applyAnimationToAnnouncementBar(event.currentTarget.name);
	}

	setSlidePosition(position) {
		if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
		this.setPositionTimeout = setTimeout(() => {
			this.slider.scrollTo({
				left: position
			});
		}, this.announcerBarAnimationDelay);
	}

	update() {
		super.update();
		this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
		this.prevButton.removeAttribute('disabled');

		if (!this.sliderControlButtons.length) return;

		this.sliderControlButtons.forEach((link) => {
			link.classList.remove('slider-counter__link--active');
			link.removeAttribute('aria-current');
		});
		this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
		this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
	}

	autoPlayToggle() {
		this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
		this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
		this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
	}

	focusOutHandling(event) {
		if (this.sliderAutoplayButton) {
			const focusedOnAutoplayButton =
				event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
			if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
			this.play();
		} else if (!this.reducedMotion.matches && !this.announcementBarArrowButtonWasClicked) {
			this.play();
		}
	}

	focusInHandling(event) {
		if (this.sliderAutoplayButton) {
			const focusedOnAutoplayButton =
				event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
			if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
				this.play();
			} else if (this.autoplayButtonIsSetToPlay) {
				this.pause();
			}
		} else if (this.announcementBarSlider.contains(event.target)) {
			this.pause();
		}
	}

	play() {
		this.slider.setAttribute('aria-live', 'off');
		clearInterval(this.autoplay);
		this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
	}

	pause() {
		this.slider.setAttribute('aria-live', 'polite');
		clearInterval(this.autoplay);
	}

	togglePlayButtonState(pauseAutoplay) {
		if (pauseAutoplay) {
			this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
			this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
		} else {
			this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
			this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
		}
	}

	autoRotateSlides() {
		const slideScrollPosition =
			this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.sliderItemOffset;

		this.setSlidePosition(slideScrollPosition);
		this.applyAnimationToAnnouncementBar();
	}

	setSlideVisibility(event) {
		this.sliderItemsToShow.forEach((item, index) => {
			const linkElements = item.querySelectorAll('a');
			if (index === this.currentPage - 1) {
				if (linkElements.length)
					linkElements.forEach((button) => {
						button.removeAttribute('tabindex');
					});
				item.setAttribute('aria-hidden', 'false');
				item.removeAttribute('tabindex');
			} else {
				if (linkElements.length)
					linkElements.forEach((button) => {
						button.setAttribute('tabindex', '-1');
					});
				item.setAttribute('aria-hidden', 'true');
				item.setAttribute('tabindex', '-1');
			}
		});
		this.wasClicked = false;
	}

	applyAnimationToAnnouncementBar(button = 'next') {
		if (!this.announcementBarSlider) return;

		const itemsCount = this.sliderItems.length;
		const increment = button === 'next' ? 1 : -1;

		const currentIndex = this.currentPage - 1;
		let nextIndex = (currentIndex + increment) % itemsCount;
		nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

		const nextSlide = this.sliderItems[nextIndex];
		const currentSlide = this.sliderItems[currentIndex];

		const animationClassIn = 'announcement-bar-slider--fade-in';
		const animationClassOut = 'announcement-bar-slider--fade-out';

		const isFirstSlide = currentIndex === 0;
		const isLastSlide = currentIndex === itemsCount - 1;

		const shouldMoveNext = (button === 'next' && !isLastSlide) || (button === 'previous' && isFirstSlide);
		const direction = shouldMoveNext ? 'next' : 'previous';

		currentSlide.classList.add(`${animationClassOut}-${direction}`);
		nextSlide.classList.add(`${animationClassIn}-${direction}`);

		setTimeout(() => {
			currentSlide.classList.remove(`${animationClassOut}-${direction}`);
			nextSlide.classList.remove(`${animationClassIn}-${direction}`);
		}, this.announcerBarAnimationDelay * 2);
	}

	linkToSlide(event) {
		event.preventDefault();
		const slideScrollPosition =
			this.slider.scrollLeft +
			this.sliderFirstItemNode.clientWidth *
				(this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
		this.slider.scrollTo({
			left: slideScrollPosition
		});
	}
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
	constructor() {
		super();
		this.addEventListener('change', this.onVariantChange);
	}

	onVariantChange(event) {
		this.updateOptions();
		this.updateMasterId();
		this.updateSelectedSwatchValue(event);
		this.toggleAddButton(true, '', false);
		this.updatePickupAvailability();
		this.removeErrorMessage();
		this.updateVariantStatuses();

		if (!this.currentVariant) {
			this.toggleAddButton(true, '', true);
			this.setUnavailable();
		} else {
			this.updateMedia();
			this.updateURL();
			this.updateVariantInput();
			this.renderProductInfo();
			this.updateShareUrl();
		}
		publish(PUB_SUB_EVENTS.updateRoyalty, getLocalStorage('selected-cause'));
	}

	updateOptions() {
		this.options = Array.from(this.querySelectorAll('select, fieldset'), (element) => {
			if (element.tagName === 'SELECT') {
				return element.value;
			}
			if (element.tagName === 'FIELDSET') {
				return Array.from(element.querySelectorAll('input')).find((radio) => radio.checked)?.value;
			}
		});
	}

	updateMasterId() {
		this.currentVariant = this.getVariantData().find((variant) => {
			return !variant.options
				.map((option, index) => {
					return this.options[index] === option;
				})
				.includes(false);
		});
	}

	updateSelectedSwatchValue({ target }) {
		const { name, value, tagName } = target;

		if (tagName === 'SELECT' && target.selectedOptions.length) {
			const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
			const selectedDropdownSwatchValue = this.querySelector(`[data-selected-dropdown-swatch="${name}"] > .swatch`);
			if (!selectedDropdownSwatchValue) return;
			if (swatchValue) {
				selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
				selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
			} else {
				selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
				selectedDropdownSwatchValue.classList.add('swatch--unavailable');
			}
		} else if (tagName === 'INPUT' && target.type === 'radio') {
			const selectedSwatchValue = this.querySelector(`[data-selected-swatch-value="${name}"]`);
			if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
		}
	}

	updateMedia() {
		if (!this.currentVariant) return;
		if (!this.currentVariant.featured_media) return;

		const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
		mediaGalleries.forEach((mediaGallery) =>
			mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true)
		);

		const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
		if (!modalContent) return;
		const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
		modalContent.prepend(newMediaModal);
	}

	updateURL() {
		if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
		window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
	}

	updateShareUrl() {
		const shareButton = document.getElementById(`Share-${this.dataset.section}`);
		if (!shareButton || !shareButton.updateUrl) return;
		shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
	}

	updateVariantInput() {
		const productForms = document.querySelectorAll(
			`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
		);
		productForms.forEach((productForm) => {
			const input = productForm.querySelector('input[name="id"]');
			input.value = this.currentVariant.id;
			input.dispatchEvent(new Event('change', { bubbles: true }));
		});
	}

	updateVariantStatuses() {
		const selectedOptionOneVariants = this.variantData.filter(
			(variant) => this.querySelector(':checked').value === variant.option1
		);
		const inputWrappers = [...this.querySelectorAll('.product-form__input')];
		inputWrappers.forEach((option, index) => {
			if (index === 0) return;
			const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
			const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
			const availableOptionInputsValue = selectedOptionOneVariants
				.filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
				.map((variantOption) => variantOption[`option${index + 1}`]);
			this.setInputAvailability(optionInputs, availableOptionInputsValue);
		});
	}

	setInputAvailability(elementList, availableValuesList) {
		elementList.forEach((element) => {
			const value = element.getAttribute('value');
			const availableElement = availableValuesList.includes(value);

			if (element.tagName === 'INPUT') {
				element.classList.toggle('disabled', !availableElement);
			} else if (element.tagName === 'OPTION') {
				element.innerText = availableElement
					? value
					: window.variantStrings.unavailable_with_option.replace('[value]', value);
			}
		});
	}

	updatePickupAvailability() {
		const pickUpAvailability = document.querySelector('pickup-availability');
		if (!pickUpAvailability) return;

		if (this.currentVariant && this.currentVariant.available) {
			pickUpAvailability.fetchAvailability(this.currentVariant.id);
		} else {
			pickUpAvailability.removeAttribute('available');
			pickUpAvailability.innerHTML = '';
		}
	}

	removeErrorMessage() {
		const section = this.closest('section');
		if (!section) return;

		const productForm = section.querySelector('product-form');
		if (productForm) productForm.handleErrorMessage();
	}

	renderProductInfo() {
		const requestedVariantId = this.currentVariant.id;
		const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

		fetch(
			`${this.dataset.url}?variant=${requestedVariantId}&section_id=${
				this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
			}`
		)
			.then((response) => response.text())
			.then((responseText) => {
				// prevent unnecessary ui changes from abandoned selections
				if (this.currentVariant.id !== requestedVariantId) return;

				const html = new DOMParser().parseFromString(responseText, 'text/html');
				const destination = document.getElementById(`price-${this.dataset.section}`);
				const source = html.getElementById(
					`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
				);
				const skuSource = html.getElementById(
					`Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
				);
				const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
				const inventorySource = html.getElementById(
					`Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
				);
				const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

				const volumePricingSource = html.getElementById(
					`Volume-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
				);

				const pricePerItemDestination = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
				const pricePerItemSource = html.getElementById(
					`Price-Per-Item-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
				);

				const volumePricingDestination = document.getElementById(`Volume-${this.dataset.section}`);
				const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);
				const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);

				if (volumeNote) volumeNote.classList.remove('hidden');
				if (volumePricingDestination) volumePricingDestination.classList.remove('hidden');
				if (qtyRules) qtyRules.classList.remove('hidden');

				if (source && destination) destination.innerHTML = source.innerHTML;
				if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
				if (skuSource && skuDestination) {
					skuDestination.innerHTML = skuSource.innerHTML;
					skuDestination.classList.toggle('hidden', skuSource.classList.contains('hidden'));
				}

				if (volumePricingSource && volumePricingDestination) {
					volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
				}

				if (pricePerItemSource && pricePerItemDestination) {
					pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
					pricePerItemDestination.classList.toggle('hidden', pricePerItemSource.classList.contains('hidden'));
				}

				const price = document.getElementById(`price-${this.dataset.section}`);

				if (price) price.classList.remove('hidden');

				if (inventoryDestination) inventoryDestination.classList.toggle('hidden', inventorySource.innerText === '');

				const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
				this.toggleAddButton(
					addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
					window.variantStrings.soldOut
				);

				publish(PUB_SUB_EVENTS.variantChange, {
					data: {
						sectionId,
						html,
						variant: this.currentVariant
					}
				});
			});
	}

	toggleAddButton(disable = true, text, modifyClass = true) {
		const productForm = document.getElementById(`product-form-${this.dataset.section}`);
		if (!productForm) return;
		const addButton = productForm.querySelector('[name="add"]');
		const addButtonText = productForm.querySelector('[name="add"] > span');
		if (!addButton) return;

		if (disable) {
			addButton.setAttribute('disabled', 'disabled');
			if (text) addButtonText.textContent = text;
		} else {
			addButton.removeAttribute('disabled');
			addButtonText.textContent = window.variantStrings.addToCart;
		}

		if (!modifyClass) return;
	}

	setUnavailable() {
		const button = document.getElementById(`product-form-${this.dataset.section}`);
		const addButton = button.querySelector('[name="add"]');
		const addButtonText = button.querySelector('[name="add"] > span');
		const price = document.getElementById(`price-${this.dataset.section}`);
		const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
		const sku = document.getElementById(`Sku-${this.dataset.section}`);
		const pricePerItem = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
		const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);
		const volumeTable = document.getElementById(`Volume-${this.dataset.section}`);
		const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);

		if (!addButton) return;
		addButtonText.textContent = window.variantStrings.unavailable;
		if (price) price.classList.add('hidden');
		if (inventory) inventory.classList.add('hidden');
		if (sku) sku.classList.add('hidden');
		if (pricePerItem) pricePerItem.classList.add('hidden');
		if (volumeNote) volumeNote.classList.add('hidden');
		if (volumeTable) volumeTable.classList.add('hidden');
		if (qtyRules) qtyRules.classList.add('hidden');
	}

	getVariantData() {
		this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
		return this.variantData;
	}
}

customElements.define('variant-selects', VariantSelects);

class ProductRecommendations extends HTMLElement {
	constructor() {
		super();
	}

	connectedCallback() {
		const handleIntersection = (entries, observer) => {
			if (!entries[0].isIntersecting) return;
			observer.unobserve(this);

			fetch(this.dataset.url)
				.then((response) => response.text())
				.then((text) => {
					const html = document.createElement('div');
					html.innerHTML = text;
					const recommendations = html.querySelector('product-recommendations');

					if (recommendations && recommendations.innerHTML.trim().length) {
						this.innerHTML = recommendations.innerHTML;
					}

					if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
						this.remove();
					}

					if (html.querySelector('.grid__item')) {
						this.classList.add('product-recommendations--loaded');
					}
				})
				.catch((e) => {
					console.error(e);
				});
		};

		new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
	}
}

customElements.define('product-recommendations', ProductRecommendations);

// ------------------------------ CUSA Custom code ------------------------------ //

// ----- Utilities ----- //

/**
 * Returns today's date in the Canadian locale format, which is 'YYYY-MM-DD'.
 *
 * @returns {string} The current date in 'YYYY-MM-DD' format.
 */
getTodaysDate = () => {
	return new Date().toLocaleDateString('en-CA');
};

/**
 * Checks for a passed url parameter and if found, returns the value
 * @returns {?string} specified parameter value, if present
 */
checkForUrlParam = (param) => {
	return new URLSearchParams(window.location.search).get(param);
};

/**
 * Smoothly scrolls the window to a specific position.
 *
 * @param {number} offsetTop - The vertical position to scroll to.
 */
scrollToElement = (offsetTop) => {
	const headerHeight = document.querySelector('header').clientHeight;
	const extraPadding = 38;
	const totalScroll = offsetTop - headerHeight - extraPadding;
	window.scrollTo({
		top: totalScroll,
		behavior: 'smooth'
	});
};

/**
 * Waits for an element matching the given selector to exist in the DOM.
 * Uses MutationObserver to listen for DOM changes and a timeout to handle slow loads.
 *
 * @param {string} selector - The CSS selector for the element to wait for.
 * @param {number} [timeout=7000] - The time in milliseconds to wait before rejecting the promise.
 * @returns {Promise<Element>} A promise that resolves when the element is found, or rejects if the timeout is reached.
 *
 * @example
 * waitForElement('#my-element').then(element => {
 *   console.log('Element found:', element);
 * }).catch(err => {
 *   console.error(err);
 * });
 */
waitForElement = (selector, timeout = 7000) => {
	return new Promise((resolve, reject) => {
		const checkElement = () => {
			const element = document.querySelector(selector);
			if (element) {
				return resolve(element);
			}
		};

		const observer = new MutationObserver((mutations, observerInstance) => {
			const element = document.querySelector(selector);
			if (element) {
				observerInstance.disconnect();
				resolve(element);
			}
		});

		observer.observe(document.body, { childList: true, subtree: true });

		checkElement();

		if (timeout != false) {
			setTimeout(() => {
				observer.disconnect();
				reject(new Error(`Element with selector "${selector}" not found within ${timeout}ms`));
			}, timeout);
		}
	});
};

/**
 * Waits for a DOM mutation on a target element, with optional timeout.
 *
 * @param {Object} options
 * @param {HTMLElement|string} options.target - DOM element or CSS selector.
 * @param {string[]} [options.mutations=[]] - Mutation types to observe ("attributes", "childList", "subtree", "characterData").
 * @param {boolean} [options.once=true] - Auto-disconnect after first mutation if true.
 * @param {number} [options.timeout] - Optional timeout in milliseconds before rejecting.
 * @returns {{ promise: Promise<MutationRecord[]>, observer: MutationObserver, disconnect: () => void }}
 */
waitForMutation = ({ target, mutations = [], once = true, timeout } = {}) => {
	const element = typeof target === 'string' ? document.querySelector(target) : target;

	if (!element) {
		return {
			promise: Promise.reject(new Error(`Target not found: ${target}`)),
			observer: null,
			disconnect: () => {}
		};
	}

	const config = {
		attributes: mutations.includes('attributes'),
		childList: mutations.includes('childList'),
		subtree: mutations.includes('subtree'),
		characterData: mutations.includes('characterData')
	};

	let resolver, rejecter, timer;
	const promise = new Promise((resolve, reject) => {
		resolver = resolve;
		rejecter = reject;
		if (timeout != null) {
			timer = setTimeout(() => {
				observer.disconnect();
				reject(new Error(`Mutation did not occur within ${timeout}ms`));
			}, timeout);
		}
	});

	const observer = new MutationObserver((mutationList, obs) => {
		const filtered = mutationList.filter((m) => config[m.type]);
		if (filtered.length > 0) {
			if (timer) clearTimeout(timer);
			resolver(filtered);
			if (once) obs.disconnect();
		}
	});

	observer.observe(element, config);

	return {
		promise,
		observer,
		disconnect: () => {
			if (timer) clearTimeout(timer);
			observer.disconnect();
			rejecter?.(new Error('Observer manually disconnected'));
		}
	};
};

/**
 * Waits for a value (nested or not) inside a given source object to become truthy.
 * @param {Object} source - The object to inspect (can be window, a component instance, etc.)
 * @param {string|null} path - Dot-notated path to the value, or null to check the root object itself.
 * @param {Object} [options]
 * @param {number} [options.interval=200] - Time in ms between checks
 * @param {number} [options.timeout=10000] - Max time to wait in ms
 * @returns {Promise<*>} - Resolves when the value is found
 */
// Simple val (not nested):
// 		waitForDataPath(window, 'someGlobalKey').then(console.log);
// Nested val:
// 		waitForDataPath(window, 'guardianData.redemptions').then(console.log);
// Component local:
// 		waitForDataPath(this, 'guardianData.awards').then(console.log);
// Root val only (no path):
// 		waitForDataPath(someObject, null).then(console.log);
waitForDataPath = (source, path = null, { interval = 200, timeout = 10000 } = {}) => {
	return new Promise((resolve, reject) => {
		let elapsed = 0;

		const getValue = () => {
			if (!path) return source;
			return path.split('.').reduce((acc, key) => acc?.[key], source);
		};

		const check = () => {
			const value = getValue();
			if (value) {
				resolve(value);
			} else if ((elapsed += interval) >= timeout) {
				reject(new Error(`Timed out waiting for path "${path || '[root]'}"`));
			} else {
				setTimeout(check, interval);
			}
		};

		check();
	});
};

/**
 * Removes HTML entities from a string and returns the unescaped version.
 *
 * @param {string} htmlString - A string containing HTML entities.
 * @returns {string} The unescaped string.
 */
unEscape = (htmlString) => {
	htmlString = htmlString.replace(/&lt;/g, '<');
	htmlString = htmlString.replace(/&gt;/g, '>');
	htmlString = htmlString.replace(/&quot;/g, '"');
	htmlString = htmlString.replace(/&#39;/g, "'");
	htmlString = htmlString.replace(/&amp;/g, '&');
	return htmlString;
};

/**
 * Reports a storage failure without letting it interrupt the caller.
 *
 * Browsers throw from the storage APIs for reasons outside our control: the origin's
 * quota may be exhausted by other scripts on the domain, the browser may report a quota
 * of zero when site data is blocked, and Firefox throws even on a *read* when it cannot
 * initialise the origin's storage database. Every helper below therefore degrades to a
 * null result instead of throwing.
 *
 * This matters most for callers that run at module scope — an unguarded throw there
 * aborts the remainder of this file for the whole page. Failures are still reported to
 * the frontend logger, because catching them removes them from the logger's global
 * error handler and we would otherwise lose all visibility.
 *
 * @param {Error} error - The error the storage API threw.
 * @param {'read'|'write'|'remove'} operation - Which access failed.
 * @param {string} storageKey - The key being accessed.
 * @param {'local'|'session'} storageType - Which store was being accessed.
 */
logStorageFailure = (error, operation, storageKey, storageType) => {
	console.warn(`Could not ${operation} ${storageKey} in ${storageType} storage:`, error.name);

	window.logFrontendError?.({
		error_message: `Handled ${storageType} storage ${operation} failure for ${storageKey}: ${error.name}`,
		error_type: 'HandledStorageError',
		error_stack: error.stack,
		context: { component: 'global.js', operation, storage_key: storageKey, storage_type: storageType }
	});
};

/**
 * Retrieves a value from *local* storage by key.
 *
 * @param {string} storageKey - The key to retrieve from local storage.
 * @returns {?string} The value stored under the given key, or null when it is absent or
 * unreadable. Callers compare against null, so that is the failure value.
 */
getLocalStorage = (storageKey) => {
	try {
		return localStorage.getItem(storageKey);
	} catch (error) {
		logStorageFailure(error, 'read', storageKey, 'local');
		return null;
	}
};

/**
 * Normalizes the content click string by keeping the first N clicks
 * and appending the most recent click, resulting in N+1 items when truncated.
 *
 * @param {string} clickString
 * @param {number} maxLength
 * @returns {{contentString: string, length: number, didTruncate: boolean}}
 */
normalizeCusaContentClicks = (clickString, maxLength = CUSA_CONTENT_CLICK_MAX) => {
	const items = clickString ? clickString.split(CUSA_CONTENT_CLICK_DELIMITER).filter(Boolean) : [];
	if (items.length < maxLength) {
		return {
			contentString: items.join(CUSA_CONTENT_CLICK_DELIMITER),
			length: items.length,
			didTruncate: false
		};
	}

	const head = items.slice(0, maxLength);
	const last = items[items.length - 1];
	const truncated = [...head, last];
	return {
		contentString: truncated.join(CUSA_CONTENT_CLICK_DELIMITER),
		length: truncated.length,
		didTruncate: true
	};
};

/**
 * Stores a key/value pair in *local* storage and returns the stored value.
 *
 * @param {string} storageKey - The key to use for local storage.
 * @param {string} storageVal - The value to store under the given key.
 * @returns {?string} The stored value as retrieved by `getLocalStorage()`, or null when
 * the write failed.
 */
setLocalStorage = (storageKey, storageVal) => {
	try {
		localStorage.setItem(storageKey, storageVal);
	} catch (error) {
		logStorageFailure(error, 'write', storageKey, 'local');
		return null;
	}

	return getLocalStorage(storageKey);
};

/**
 * Retrieves a value from *session* storage by key.
 *
 * @param {string} storageKey - The key to retrieve from session storage.
 * @returns {?string} The value stored under the given key, or null when it is absent or
 * unreadable.
 */
getSessionStorage = (storageKey) => {
	try {
		return sessionStorage.getItem(storageKey);
	} catch (error) {
		logStorageFailure(error, 'read', storageKey, 'session');
		return null;
	}
};

/**
 * Removes a key/value pair in *local* storage and returns confirmation it has been removed by checking for the value.
 *
 * @param {string} storageKey - The key to remove from local storage.
 * @returns {string} The stored value as retrieved by `getLocalStorage()`.
 */
removeLocalStorage = (storageKey) => {
	try {
		localStorage.removeItem(storageKey);
	} catch (error) {
		logStorageFailure(error, 'remove', storageKey, 'local');
		return;
	}

	if (!getLocalStorage(storageKey)) console.log(`Removed localStorage item: ${storageKey}`);
};

/**
 * Stores a key/value pair in *session* storage and returns the stored value.
 *
 * @param {string} storageKey - The key to use for session storage.
 * @param {string} storageVal - The value to store under the given key.
 * @returns {?string} The stored value as retrieved by `getSessionStorage()`, or null when
 * the write failed.
 */
setSessionStorage = (storageKey, storageVal) => {
	try {
		sessionStorage.setItem(storageKey, storageVal);
	} catch (error) {
		logStorageFailure(error, 'write', storageKey, 'session');
		return null;
	}

	return getSessionStorage(storageKey);
};

removeDuplicateObjects = (arrayOfObjs, keyForComparison) => {
	const seen = new Set();
	const dedupedArray = arrayOfObjs.filter((obj) => {
		const identifier = obj[keyForComparison];
		if (seen.has(identifier)) {
			return false;
		}
		seen.add(identifier);
		return true;
	});
	return dedupedArray;
};

/**
 * Removes the given element from the DOM while preserving and promoting its child nodes.
 *
 * This effectively "unwraps" the element, moving all children to the element's parent
 * in the same position as the original element.
 *
 * @param {Element} element - The DOM element to unwrap.
 */
unwrapElement = (element) => {
	if (!element || !element.parentNode) return;

	while (element.firstChild) {
		element.parentNode.insertBefore(element.firstChild, element);
	}

	element.remove();
};

/**
 * Replaces a given DOM element with a new one of a different tag type.
 *
 * @param {Element} element - The DOM element to be replaced.
 * @param {Object} [options={}] - Optional settings for the replacement.
 * @param {string} options.newTagType - The tag name for the new element (e.g., 'button', 'div').
 * @param {string} [options.classes] - Optional classes to apply to the new element.
 * @param {Object} [options.attributes] - Optional attributes to set on the new element.
 * @param {string|null} [options.newContent] - Optional HTML string to replace the inner content.
 * @param {boolean} [options.preserveListeners=false] - If true, creates a clone (does not preserve listeners automatically).
 * @param {boolean} [options.rebindListeners=false] - If true, rebinds event listeners provided via `options.listeners`.
 * @param {Array<{type: string, handler: Function, options?: boolean|AddEventListenerOptions}>} [options.listeners] - List of event listeners to add to the new element.
 * @returns {Element|null} The newly created and inserted element, or null if inputs are invalid.
 */
replaceTag = (element, options = {}) => {
	if (!element || typeof options.newTagType !== 'string') {
		console.error('Element and options.newTagType are required.');
		return null;
	}

	const {
		newTagType,
		classes = '',
		attributes = {},
		newContent = null,
		preserveListeners = false,
		rebindListeners = false,
		listeners = []
	} = options;

	// Note: This implementation does not support SVG namespace elements.
	// If replacing SVG tags (like <circle>, <rect>, etc.), use createElementNS instead.
	const newEl = document.createElement(newTagType);
	newEl.className = classes || element.className;

	for (const [name, value] of Object.entries(attributes)) {
		newEl.setAttribute(name, value);
	}

	newEl.style.cssText = element.style.cssText;

	if (newContent !== null) {
		newEl.innerHTML = newContent;
	} else {
		while (element.firstChild) {
			newEl.appendChild(element.firstChild);
		}
	}

	element.replaceWith(newEl);

	if (preserveListeners && !rebindListeners) {
		console.warn(
			'[replaceTag]: preserveListeners was set to true, but no rebindListeners. Event listeners are NOT transferred.'
		);
	}

	if (rebindListeners && (!Array.isArray(listeners) || listeners.length === 0)) {
		console.warn(
			'[replaceTag]: rebindListeners is true but no listeners were provided. No event listeners were attached to the new element.'
		);
	}

	if (rebindListeners && Array.isArray(listeners)) {
		listeners.forEach(({ type, handler, options }) => {
			newEl.addEventListener(type, handler, options || false);
		});
	}

	return newEl;
};

/**
 * Registers one or more cart attribute updates and batches them into a single
 * Shopify `/cart/update.js` request after a short debounce.
 *
 * This prevents race conditions and overwrites when multiple systems attempt to
 * write to `cart.attributes` at the same time.
 *
 * @function registerCartAttributeUpdate
 * @global
 * @param {Object} partialAttrs - Key/value pairs representing one or more cart attributes to update.
 * @example
 * registerCartAttributeUpdate({
 *   Cause: 'Local Animal Shelter',
 *   Site: 'Landing Page A'
 * });
 *
 * // This will be merged with any other pending updates and sent in a single call
 * // to Shopify after 100ms (or sooner if idle time is available).
 */
let pendingCartAttributeUpdates = {};
let cartResetTimer = null;

/**
 * Attempts to update Shopify cart attributes via `/cart/update.js` with retry logic.
 *
 * Retries are useful for handling transient network failures or temporary 5xx errors.
 * If the update fails after all attempts, an error is thrown.
 *
 * @param {Object} payload - Key-value pairs to set in the cart attributes.
 * @param {number} [maxAttempts=3] - Maximum number of retry attempts.
 * @param {number} [delay=500] - Delay (in ms) between retry attempts.
 * @returns {Promise<Response>} - Resolves with the fetch response if successful.
 * @throws {Error} - If all retry attempts fail.
 */
// Helper function for safe cart updates with retries
async function safeCartUpdate(payload, maxAttempts = 3, delay = 500) {
	let attempts = 0;

	while (attempts < maxAttempts) {
		try {
			const res = await cusaFetch(CUSA_ENDPOINTS.cartUpdate, 'POST', JSON.stringify({ attributes: payload }));

			if (res?.ok || (res && res.data && res.response && res.response.ok)) {
				return res;
			}
		} catch (err) {
			console.warn(`Cart update failed (attempt ${attempts + 1}):`, err);
		}

		await new Promise((r) => setTimeout(r, delay));
		attempts++;
	}

	throw new Error('Cart update failed after retries.');
}

window.registerCartAttributeUpdate = function (partialAttrs, logUpdate = false) {
	Object.assign(pendingCartAttributeUpdates, partialAttrs);

	if (!cartResetTimer) {
		cartResetTimer = setTimeout(async () => {
			const mergedAttrs = { ...pendingCartAttributeUpdates };
			const __beforeAttrs = { ...(window.cusaCartAttributes || {}) };
			try {
				const res = await safeCartUpdate(mergedAttrs);
				if (res && res.data?.attributes) {
					/**
					 * Updates the global cache of cart attributes.
					 *
					 * This allows other scripts to access the latest known state of Shopify cart attributes
					 * without making additional network requests.
					 * Used for coordination between tracking, cause/site metadata, and other logic
					 * that depends on cart-level metadata.
					 */
					window.cusaCartAttributes = res.data.attributes;

					const lastCartUpdateContext = window.cusaLastCartUpdateContext;
					if (lastCartUpdateContext && lastCartUpdateContext.type === 'self-heal') {
						const __dev = __cusaIsDevEnv();
						if (__dev) {
							const __after = res.data.attributes || {};
							const healed = !!(__after.Cause && __after.Site);
							console.group(healed ? '🩹 Self-heal result: ✅ Healed' : '🩹 Self-heal result: ❌ Not healed');
							console.log('Before:', lastCartUpdateContext.before);
							console.log('Attempted payload:', mergedAttrs);
							console.log('After:', { Cause: __after.Cause || null, Site: __after.Site || null });
							console.groupEnd();
						}
					}
					window.cusaLastCartUpdateContext = null;

					publish(PUB_SUB_EVENTS.cartWriteComplete, res.data.attributes);
					logUpdate && console.log('Cart attributes updated:', res.data.attributes);
				}
			} catch (err) {
				console.error('Cart update failed:', err);
			} finally {
				pendingCartAttributeUpdates = {};
				cartResetTimer = null;
			}
		}, 100); // Adjust debounce as needed
	}
};

// Derive Site from the cause selector element; do not persist to localStorage
function getSiteNameFromDom() {
	const el = document.querySelector('cusa-cause-selector');
	return el?.getAttribute('data-site-name') || el?.dataset?.siteName || null;
}

// Best-effort read of the selected cause label from the DOM (fallback if LS missing)
function getSelectedCauseNameFromDom() {
	const root = document.querySelector('cusa-cause-selector');
	if (!root) return null;
	// Prefer an explicit label holder if present
	const currentLabel = root.querySelector('[data-selected-cause-label]');
	if (currentLabel && currentLabel.textContent) {
		return currentLabel.textContent.trim();
	}
	// Otherwise infer from a checked radio and its <label>
	const checked = root.querySelector('input[type="radio"]:checked');
	if (checked) {
		const lbl = root.querySelector(`label[for="${checked.id}"]`);
		return (lbl?.textContent || checked.value || '').trim() || null;
	}
	return null;
}

function __cusaIsDevEnv() {
	const h = window.location.hostname;
	return h === 'localhost' || h === '127.0.0.1' || h.includes('test.');
}

/**
 * Ensures cart attributes `Cause` and `Site` are present once tracking is active.
 * If either is missing but we can resolve values locally, it re-registers them via the
 * batching aggregator. Source of truth: Cause comes from localStorage (fallback: DOM),
 * Site comes from the DOM (cusa-cause-selector[data-site-name]). No hostname fallback.
 */
function ensureCauseAndSiteFromStorage() {
	const attrs = window.cusaCartAttributes || {};
	if (!attrs._cusa_click_tracking_is_active) return;

	const needsRepair = !attrs.Cause || !attrs.Site;
	if (!needsRepair) return;

	const causeFromLs = getLocalStorage('selected-cause-name');
	const causeFromDom = causeFromLs ? null : getSelectedCauseNameFromDom();
	const causeName = causeFromLs || causeFromDom;
	const siteName = getSiteNameFromDom();
	if (!causeName || !siteName) return;

	// If LS was missing and we sourced from the DOM, persist for next time (no Site LS)
	if (!causeFromLs && causeFromDom) {
		setLocalStorage('selected-cause-name', causeFromDom);
	}

	// ---- Debug: log self-heal attempt and tag context ----
	if (__cusaIsDevEnv()) {
		console.group('🩹 Self-heal: attempting to repair cart attributes');
		console.log('Reason (missing):', { Cause: !attrs.Cause, Site: !attrs.Site });
		console.log('Source:', { Cause: causeFromLs ? 'localStorage' : 'dom', Site: 'dom' });
		console.log('Using values:', { Cause: causeName, Site: siteName });
		console.groupEnd();
	}

	/** Context for the most recent cart update attempt (debug-only). */
	window.cusaLastCartUpdateContext = {
		type: 'self-heal',
		source: { Cause: causeFromLs ? 'localStorage' : 'dom', Site: 'dom' },
		before: { Cause: attrs.Cause || null, Site: attrs.Site || null },
		attemptAt: Date.now()
	};

	window.registerCartAttributeUpdate({
		Cause: causeName,
		Site: siteName
	});
}

// Re-check after any cart write completes (covers the case where tracking flag lands first)
if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
	subscribe(PUB_SUB_EVENTS.cartWriteComplete, (newAttrs) => {
		// Defensive: normalize to object
		const payload = newAttrs && typeof newAttrs === 'object' ? newAttrs : window.cusaCartAttributes || {};
		if (payload && payload._cusa_click_tracking_is_active) {
			ensureCauseAndSiteFromStorage();
		}
	});
}

// Also attempt once on DOM ready in case tracking flag was already present
if (document.readyState === 'complete' || document.readyState === 'interactive') {
	setTimeout(ensureCauseAndSiteFromStorage, 0);
} else {
	document.addEventListener('DOMContentLoaded', () => setTimeout(ensureCauseAndSiteFromStorage, 0), { once: true });
}

/**
 * Creates a small floating debug panel on dev/test environments
 * for viewing and clearing cart update logs stored in localStorage.
 * Also mounts debug buttons for cart logs and cart attributes.
 */
function mountCartDebugPanel() {
	const isDevEnv =
		window.location.hostname === 'localhost' ||
		window.location.hostname === '127.0.0.1' ||
		window.location.hostname.includes('test.');
	if (!isDevEnv) return;

	const panel = document.createElement('div');
	panel.style = `
    position: fixed;
    bottom: 1rem;
    right: 1rem;
    background: white;
    border: 1px solid #ccc;
    padding: 0.5rem 1rem;
    font-size: 12px;
    font-family: monospace;
    z-index: 9999;
    box-shadow: 0 0 10px rgba(0,0,0,0.2);
  `;

	const viewBtn = document.createElement('button');
	viewBtn.textContent = '💾 View Local Storage';
	viewBtn.setAttribute('data-debug-cause-site-storage', '');

	const attrsBtn = document.createElement('button');
	attrsBtn.textContent = '🛒 View Cart Attributes';
	attrsBtn.setAttribute('data-debug-cart-attrs', '');
	attrsBtn.style.marginLeft = '0.5rem';

	const winCusaAttrsBtn = document.createElement('button');
	winCusaAttrsBtn.textContent = '🪟 View Window Attributes';
	winCusaAttrsBtn.setAttribute('data-debug-win-cart-attrs', '');
	winCusaAttrsBtn.style.marginLeft = '0.5rem';

	const clearCauseSiteBtn = document.createElement('button');
	clearCauseSiteBtn.textContent = '🧹 Clear Cause/Site';
	clearCauseSiteBtn.setAttribute('data-debug-clear-cause-site', '');
	clearCauseSiteBtn.style.marginLeft = '0.5rem';

	panel.appendChild(viewBtn);
	panel.appendChild(attrsBtn);
	panel.appendChild(winCusaAttrsBtn);
	panel.appendChild(clearCauseSiteBtn);
	document.body.appendChild(panel);

	// Wire up debug actions
	viewBtn.addEventListener('click', () => {
		const selectedCause = getLocalStorage('selected-cause');
		const selectedCauseName = getLocalStorage('selected-cause-name');
		console.group('🛒 Cart-Related LocalStorage');
		console.log('selected-cause:', selectedCause ?? '—');
		console.log('selected-cause-name:', selectedCauseName ?? '—');
		console.groupEnd();
	});

	attrsBtn.addEventListener('click', async () => {
		console.group('🛒 Shopify Cart Attributes');
		try {
			const result = await fetch(CUSA_ENDPOINTS.cart);
			const data = await result.json();
			console.log(data.attributes || '🫥 No attributes set on cart.');
		} catch (err) {
			console.error('🚨 Failed to load cart attributes:', err);
		}
		console.groupEnd();
	});

	winCusaAttrsBtn.addEventListener('click', () => {
		console.group('🪟 Window CUSA Attributes');
		console.log(window.cusaCartAttributes || '🫥 No CUSA window attributes set.');
		console.groupEnd();
	});

	clearCauseSiteBtn.addEventListener('click', async () => {
		await clearCauseAndSiteAttributes();
	});
}

// Automatically mount debug panel in dev/test environments
if (getLocalStorage('cusaCartAttributesDebugPanel') === 'enabled') {
	mountCartDebugPanel();
}

/**
 * Clears all cart attributes except for 'Site', 'Cause', and those with 'elevar' in the name.
 */
clearAllCartAttributes = async () => {
	const current =
		window.cusaCartAttributes && typeof window.cusaCartAttributes === 'object' ? window.cusaCartAttributes : {};

	const bodyData = { attributes: {} };

	for (const key of Object.keys(current)) {
		if (key !== 'Site' && key !== 'Cause' && !key.toLowerCase().includes('elevar')) {
			bodyData.attributes[key] = '';
		}
	}

	if (!Object.keys(bodyData.attributes).length) {
		console.info('[CUSA] No cart attributes to clear.');
		return;
	}

	const result = await cusaFetch(CUSA_ENDPOINTS.cartUpdate, 'POST', JSON.stringify(bodyData));

	if (result && result.data?.attributes) {
		window.cusaCartAttributes = result.data.attributes;
	}
};

/**
 * Clears only the `Cause` and `Site` cart attributes.
 * Updates `window.cusaCartAttributes` to reflect the latest server state.
 *
 * @param {Object} [opts]
 * @param {boolean} [opts.log=true] - Whether to log the result to the console.
 */
async function clearCauseAndSiteAttributes({ log = true } = {}) {
	try {
		const payload = { attributes: { Cause: '', Site: '' } };
		const result = await cusaFetch(CUSA_ENDPOINTS.cartUpdate, 'POST', JSON.stringify(payload));

		if (result && result.data?.attributes) {
			// Sync window mirror to server-confirmed state
			window.cusaCartAttributes = result.data.attributes;
		} else if (window.cusaCartAttributes && typeof window.cusaCartAttributes === 'object') {
			// Defensive: reflect the intent locally if server did not echo attributes
			delete window.cusaCartAttributes.Cause;
			delete window.cusaCartAttributes.Site;
		}

		if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
			publish(PUB_SUB_EVENTS.cartWriteComplete, window.cusaCartAttributes || {});
		}

		if (log) console.info('[CUSA] Cleared Cause/Site. Current attrs:', window.cusaCartAttributes || {});
	} catch (err) {
		console.error('[CUSA] Failed to clear Cause/Site cart attributes:', err);
	}
}

// Expose for console-driven debugging if needed
window.clearCauseAndSiteAttributes = clearCauseAndSiteAttributes;

/**
 * Clears all local storage data related to CUSA content click tracking.
 */
clearAllStoredCusaContentClickData = async () => {
	removeLocalStorage('cusa-content-clicks');
};

/**
 * Clears all cart attributes except for 'Site', 'Cause', and those with 'elevar' in the name.
 * Also clears all local storage data related to CUSA content click tracking.
 */
clearAllCusaContetClickData = () => {
	clearAllCartAttributes();
	clearAllStoredCusaContentClickData();
};

/**
 * Thin fetch wrapper for direct calls to the Guardians API (or any endpoint where
 * we want automatic network-failure logging).
 *
 * Catches network-layer rejections (Failed to fetch, aborts, CORS), logs them via
 * window.logFrontendError, and re-throws so callers can still handle the error.
 *
 * Does NOT catch HTTP 4xx/5xx responses — call sites still check `response.ok`
 * and handle the response body their own way. Add an inline logFrontendError
 * call in the !response.ok branch if HTTP-error coverage is needed there too.
 *
 * Does NOT publish PUB_SUB_EVENTS.guardianFetchFailed — only cusaFetch does that.
 *
 * @param {RequestInfo | URL} input
 * @param {RequestInit} [init]
 * @returns {Promise<Response>}
 */
const loggedFetch = async (input, init) => {
	try {
		return await fetch(input, init);
	} catch (err) {
		const endpoint = input instanceof Request ? input.url : String(input);
		window.logFrontendError?.({
			error_message: err?.message || String(err),
			error_type: err?.name || 'LoggedFetchError',
			error_stack: err?.stack,
			context: { endpoint, method: init?.method || 'GET' }
		});
		throw err;
	}
};

/**
 * A utility function for sending fetch requests.
 * Supports optional bodyObj and contentType parameters.
 *
 * @param {String} url - Endpoint for the fetch request.
 * @param {String} method - HTTP method, "GET" or "POST".
 * @param {{}} [bodyObj] - Optional object containing the request body.
 * @param {String} [contentType] - Optional content type for the request, defaults to 'application/json'.
 * @returns {Promise<Object>} The response JSON.
 */
const cusaFetch = async (url, method, bodyObj, contentType) => {
	bodyObj = bodyObj || null;
	contentType = contentType || 'application/json';
	let fetchObj = {
		method: method,
		headers: {
			'Content-Type': `${contentType}`,
			Accept: `${contentType}`
		}
	};
	if (bodyObj) {
		fetchObj.body = bodyObj;
	}

	try {
		console.log(`Sending request to '${url}'…`);
		const response = await fetch(url, fetchObj);
		let dataText = await response.text();
		let data;

		try {
			data = JSON.parse(dataText);
		} catch {
			data = dataText; // fallback to string like "Saved"
		}

		if (!response.ok) {
			const err = new Error(`Returned status ${response.status}: ${response.statusText}. 
Server replied with: "${Array.isArray(data?.error) ? data.error[0] : data?.error || 'No error message'}"`);
			err.status = response.status;
			err.response = response;
			err.data = data;
			throw err;
		} else {
			return { response, data };
		}
	} catch (error) {
		// A 422 means the server understood the request and refused it on a business rule.
		// That is a valid answer, not a broken request, so it must not look like a failure.
		const serverMessage = Array.isArray(error.data?.error) ? error.data.error[0] : error.data?.error;
		const isBusinessRule = error.status === 422;

		// An unknown action type is a real misconfiguration and has to stay visible in logging.
		const isUnknownActionType = isBusinessRule && /Unknown action type/i.test(serverMessage || '');

		if (isBusinessRule) {
			console.warn(`cusaFetch() refused by server: ${serverMessage || error.message}`);
		} else {
			publish(PUB_SUB_EVENTS.guardianFetchFailed);
			console.error('cusaFetch() failed', error);
		}

		console.warn(`cusaFetch() failure was triggered from '${url}'`);

		if (!isBusinessRule || isUnknownActionType) {
			window.logFrontendError?.({
				error_message: error.message,
				error_type: error.constructor?.name || 'FetchError',
				error_stack: error.stack,
				context: { endpoint: url, status: error.status }
			});
		}
		throw error;
	}
};

/**
 * Logs a successful fetch request as a formatted message.
 *
 * @param {String} resStatusCode - The response status code.
 * @param {String} identifier - A name, ID, or identifier related to the fetch action.
 * @param {String} returnedMsg - The message returned in the data object.
 */
const logFetchSuccess = (resStatusCode, identifier, returnedMsg) => {
	console.log(
		`
%c———————————————————————————————————————————————————————————————%c
✅ Status ${resStatusCode}: ${identifier} click ${returnedMsg.toLowerCase()}%c———————————————————————————————————————————————————————————————%c`,
		'color: lime',
		'color: inherit',
		'color: lime',
		'color: inherit'
	);
};

/**
 * Uses the `cusaFetch()` function to retrieve the contents of the cart.
 *
 * @returns {Promise<Object>} The result of the fetch call as {response, data}.
 */
const getCart = async () => {
	const result = await cusaFetch(CUSA_ENDPOINTS.cart, 'GET');
	return result;
};

/**
 * Mocks a fetch call with configurable delay, response shape, and error conditions.
 *
 * @param {Object} [options={}] - Configuration options for the mocked fetch.
 * @param {Object} [options.response={}] - Optional. Mock response object including `status`, `ok`, and `headers`. Default: {}
 * @param {*} [options.data=null] - Optional. Response data returned from `.json()`, `.text()`, or `.formData()`. Default: null
 * @param {'json'|'text'|'formData'} [options.format='json'] - Optional. Format of the response body. Default: 'json'
 * @param {number} [options.delay=300] - Optional. Delay in milliseconds before resolving or rejecting. Default: 300
 * @param {boolean|string} [options.shouldReject=false] - Optional. Set `true` to simulate HTTP failure, `'network'` to simulate a network error. Default: false
 * @param {boolean} [options.useCusaFetchFormat=false] - Optional. If true, resolves as { response, data } like cusaFetch. Default: false
 * @returns {Promise<Object>} - A Promise resolving to a mock Response-like object or rejecting with an error or the same mock.
 */

const mockFetch = ({
	response = {},
	data = null,
	delay = 300,
	shouldReject = false, // true, false, or 'network'
	format = 'json', // 'json', 'text', or 'formData'
	useCusaFetchFormat = false // Optional. If true, resolves as { response, data } like cusaFetch. Default: false
} = {}) => {
	return new Promise((resolve, reject) => {
		setTimeout(() => {
			if (shouldReject === 'network') {
				const mockResponse = {
					ok: false,
					status: response.status ?? 500,
					statusText: response.statusText ?? 'Network Error',
					headers: response.headers ?? {
						'Content-Type': {
							json: 'application/json',
							text: 'text/plain',
							formData: 'multipart/form-data'
						}[format]
					},
					url: 'mock://url',
					json: () => Promise.reject(new Error('Network request failed')),
					text: () => Promise.reject(new Error('Network request failed')),
					formData: () => Promise.reject(new Error('Network request failed')),
					clone: () => mockResponse
				};
				reject(new TypeError('Network request failed'));
				return;
			}

			const finalStatus = response.status ?? 200;
			const finalOk = response.ok ?? (finalStatus >= 200 && finalStatus < 300);
			const headers = response.headers ?? {
				'Content-Type': {
					json: 'application/json',
					text: 'text/plain',
					formData: 'multipart/form-data'
				}[format]
			};
			const statusText = response.statusText ?? (finalOk ? 'OK' : 'Error');

			const buildBody = () => {
				if (format === 'json') return Promise.resolve(data);
				if (format === 'text') return Promise.resolve(typeof data === 'string' ? data : JSON.stringify(data));
				if (format === 'formData') {
					if (data instanceof FormData) return Promise.resolve(data);
					const fd = new FormData();
					if (data && typeof data === 'object') {
						Object.entries(data).forEach(([key, value]) => fd.append(key, value));
					}
					return Promise.resolve(fd);
				}
				return Promise.reject(new Error(`Unsupported format: ${format}`));
			};

			const mockResponse = {
				ok: finalOk,
				status: finalStatus,
				statusText,
				headers,
				url: 'mock://url',
				json: () => (format === 'json' ? buildBody() : Promise.reject(new Error('Response is not JSON'))),
				text: () => (format === 'text' ? buildBody() : Promise.reject(new Error('Response is not plain text'))),
				formData: () => (format === 'formData' ? buildBody() : Promise.reject(new Error('Response is not FormData'))),
				clone: () => mockResponse
			};

			if (shouldReject === true || !finalOk) {
				reject(mockResponse);
			} else {
				resolve(useCusaFetchFormat ? { response: mockResponse, data } : mockResponse);
			}
		}, delay);
	});
};

/**
 * Posts all CTG button clicks to the CUSA middleware regardless
 * of logged in status. This is only for CTG clicks.
 *
 * @param {String} causeHandle - The handle of the cause metaobject.
 * @returns {Promise<Object>} The response.
 */
const countCtgButtonClick = async (causeHandleArray) => {
	const bodyData = {
		action_types: causeHandleArray
	};

	let fetchObj = {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			Accept: 'application/json'
		},
		body: JSON.stringify(bodyData)
	};

	try {
		console.log('Sending CTG click request…');
		const response = await loggedFetch(CUSA_ENDPOINTS.allClicks, fetchObj);
		if (!response.ok) {
			throw new Error(`Response status: ${response.status}`);
		} else {
			logFetchSuccess(response.status, causeHandleArray, 'counted');
		}
	} catch (error) {
		console.error('countCtgButtonClick() failed', error);
		const specificName = error?.constructor?.name && error.constructor.name !== 'Error' ? error.constructor.name : null;
		window.logFrontendError?.({
			error_message: error.message,
			error_type: specificName || 'CtgClickError',
			error_stack: error.stack,
			context: { endpoint: CUSA_ENDPOINTS.allClicks }
		});
	}
};

/**
 * Uses `cusaFetch()` to post CTG & Guardians clicks to the CUSA middleware.
 * This is used for CTG click boxes and Guardians Earn Tab clicks.
 *
 * @param {String} causeHandle - The handle of the cause metaobject.
 * @returns {Promise<Object>} The member summary data from the fetch call.
 */
const postGuardiansClick = async (causeHandleArray) => {
	const bodyData = {
		types: causeHandleArray
	};
	try {
		const result = await cusaFetch(CUSA_ENDPOINTS.clicks, 'POST', JSON.stringify(bodyData));

		if (!result) return;

		const response = result.response;
		const data = result.data;

		if (response && data) {
			logFetchSuccess(response.status, causeHandleArray, data.message);

			// Publish stats update and share data
			setGGGWinVarAndPub(data);
			return data;
		} else {
			throw new Error('Unexpected result structure:', result);
		}
	} catch (error) {
		// A refused claim is expected traffic. cusaFetch has already reported it at the right level.
		// Returned rather than swallowed so the caller can tell a refusal from a network failure.
		if (error.status === 422) {
			console.warn('postGuardiansClick() claim not recorded', error.data?.error || error.message);
			return { refused: true, reason: error.data?.error || error.message };
		}

		console.error('postGuardiansClick() failed', error);
	}
};

/** Retrieves the value of a URL parameter by key.
 *
 * @param {String} paramKey - The key of the URL parameter to retrieve.
 * @returns {String|null} The value of the URL parameter, or null if not found.
 */
getParam = (paramKey) => {
	return new URLSearchParams(window.location.search).get(paramKey);
};

getProgressPercentage = (currentNum, totalNum) => {
	return Math.floor((currentNum / totalNum) * 100);
};

/**
 * Updates the appearance of an award card within the Awards tab of the account page.
 * Marks the card as 'unlocked' based on the inner wrapper selector.
 *
 * @param {HTMLElement} awardCardInnerWrapper - The inner wrapper element of the award card.
 */
updateAwardCard = (awardCardInnerWrapper, isUnlocked, currentAwardNum, progressPercentage) => {
	// console.log(awardCardInnerWrapper.closest('.award-card').id);
	if (isUnlocked) {
		awardCardInnerWrapper.classList.remove('locked');
		awardCardInnerWrapper.querySelector('.award-complete-msg').classList.remove('hidden');
		awardCardInnerWrapper.querySelector('.award-progress-bar').classList.add('hidden');
		awardCardInnerWrapper.querySelector('.active-description').classList.remove('hidden');
		awardCardInnerWrapper.querySelector('.inactive-description').classList.add('hidden');
		awardCardInnerWrapper.querySelector('.current-award-num').textContent =
			awardCardInnerWrapper.querySelector('.award-min').textContent;
	} else {
		// console.log('currentAwardNum = ', currentAwardNum, 'progressPercentage = ', progressPercentage);
		const currentStatEl = awardCardInnerWrapper.querySelector('.current-award-num');
		currentStatEl.textContent = currentAwardNum;
		formatStatEl(currentStatEl);
		const percentComplete = `${progressPercentage}%`;
		awardCardInnerWrapper.querySelector('.award-progress-fill').style.width = percentComplete;
		// console.log(awardCardInnerWrapper, isUnlocked, currentAwardNum, percentComplete);
	}
};

/**
 * Tests the display of the Guardians Award modal by showing a specific award based on its index.
 *
 * @param {number} awardObjIndex - The index of the award object in the guardians awards data array.
 */
testGuardiansAwardModal = (awardObjIndex) => {
	const awardModal = document.querySelector('cusa-guardians-award-modal');
	const guardiansAwardsData = JSON.parse(awardModal.querySelector('#GuardiansAwardsData').innerHTML);
	awardModal.showAwardModal(guardiansAwardsData[awardObjIndex]);
};

/**
 * Formats the displayed stats by converting numbers to locale strings.
 */
formatStats = () => {
	for (const el of document.querySelectorAll('.format-num')) {
		// The placeholder argument to formatStatEl defaults to 0,
		// so passing nothing will always show 0 instead of NaN.
		formatStatEl(el);
	}
};

/**
 * Safely formats numeric text content.
 * 1. Normalizes input as "en-US" to prevent locale parsing issues.
 * 2. Outputs formatted value in the user’s locale (default) or a specified locale.
 * If the value is not a valid number, falls back to a placeholder value (default: 0).
 * Also removes any adjacent loading spinner and resets styles when loading finishes.
 *
 * @param {HTMLElement} statElement - The element containing the numeric value to format.
 * @param {string|number} [placeholder=0] - Value to display if the content is not a valid number.
 * @param {string|string[]} [locale=undefined] - Locale to use for output formatting. Default is user’s browser locale.
 * @returns {void}
 */
formatStatEl = (statElement, placeholder = 0, locale = undefined) => {
	const el = statElement;
	let elVal = el.textContent.trim();

	// Hybrid parsing approach:
	// 1. If no digits, bail out and preserve text (not a number).
	if (!/[0-9]/.test(elVal)) {
		console.warn(`[formatStatEl] No digits found in value: "${elVal}"`);
		el.textContent = String(placeholder);
	} else {
		let parsed = NaN;
		let cleaned = elVal;
		// 2. First, strip only commas and spaces, then parse
		cleaned = cleaned.replace(/[, ]+/g, '');
		parsed = Number(cleaned);
		if (!Number.isFinite(parsed)) {
			// 3. If parsing fails, run a relaxed cleanup (remove all non-numeric except . and -)
			cleaned = elVal.replace(/[^\d.-]/g, '');
			parsed = Number(cleaned);
		}
		if (Number.isFinite(parsed)) {
			// Output in user’s locale or specified locale
			el.textContent = parsed.toLocaleString(locale);
		} else {
			console.warn(`[formatStatEl] Invalid number value after parsing: "${elVal}"`);
			el.textContent = String(placeholder);
		}
	}

	// Handle spinner cleanup
	const spinner = el.closest('div')?.querySelector('.loading__spinner');
	if (spinner) {
		spinner.remove();
		el.style.opacity = '1';
		setTimeout(() => {
			el.classList.remove('stat-value');
			el.removeAttribute('style');
			if (el.classList.length === 0) {
				el.removeAttribute('class');
			}
		}, 2500);
	}
};

// ----- Listrak ----- //
const listrakATC = async () => {
	// Listrak may be gated off this surface (settings.listrak_gate_enabled); without the SDK there is nothing to submit.
	if (typeof _ltk === 'undefined' || !_ltk.SCA) return;
	const res = await getCart();
	const cart = await res.data;
	// console.log(cart);

	cart.items.map((item) => {
		_ltk.SCA.AddItemWithLinks(
			item.sku,
			item.quantity,
			(item.price * 0.01).toFixed(2).toString(),
			item.title,
			item.image,
			`${window.origin}${item.url}`
		);
	});

	_ltk.SCA.Total = (cart.total_price * 0.01).toFixed(2).toString();
	cart.items.length === 0 ? _ltk.SCA.ClearCart() : null;
	_ltk.SCA.Submit();
};

const debouncedListrakATC = debounce(listrakATC, ON_CHANGE_DEBOUNCE_TIMER);

subscribe(PUB_SUB_EVENTS.cartUpdate, () => debouncedListrakATC());
